import lf from 'lovefield'

export function const_enginsvaleurparametres (schemaBuilder) {
  schemaBuilder.createTable('const_enginsvaleurparametres')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('const_engins_id', lf.Type.INTEGER)
      .addColumn('const_parametresmateriels_id', lf.Type.INTEGER)
      .addColumn('data', lf.Type.STRING)
      .addColumn('annee', lf.Type.INTEGER)
      .addPrimaryKey(['id'])
      // .addIndex('constFamillesengins_id', ['constFamillesengins_id']);
}

/*
CREATE TABLE IF NOT EXISTS `const-engins` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(8) NOT NULL,
  `nom` varchar(30) NOT NULL,
  `const-famillesengins_id` int(11) NOT NULL,
  `description` text NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code_engin` (`code`),
  UNIQUE KEY `id` (`id`),
  KEY `const-famillesengins_id` (`const-famillesengins_id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=35 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constEnginsvaleurparametres.schema.js